/* MetaLife Intro — optional entrance animation */
(() => {
  if (customElements.get('metalife-intro')) return;

  customElements.define(
    'metalife-intro',
    class extends HTMLElement {
      connectedCallback() {
        if (
          this.dataset.animate !== 'true' ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          (window.Shopify && window.Shopify.designMode)
        ) {
          return;
        }

        const inner = this.querySelector('.ml-intro__inner');

        if (!inner || typeof inner.animate !== 'function') return;

        this.motion = inner.animate(
          [
            { opacity: 0.75, transform: 'translateY(6px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          {
            duration: 280,
            easing: 'ease-out'
          }
        );
      }

      disconnectedCallback() {
        if (this.motion) this.motion.cancel();
      }
    }
  );
})();